import React, { useEffect } from "react";
import { Button } from "react-md/lib/Buttons";
import { connect } from "react-redux";
import { getPhotoButtonHoverSetting, photoToolButtonHoverOptions } from "components/Photos/PhotoTool/Shared";
import { UserPreference } from "interfaces/Mueller.Business.Models";

const navigateForward = (selectedPhotoIndex: number, photoCount: number) => {
  switch (selectedPhotoIndex) {
    case photoCount - 1:
      return 0;
    default:
      return selectedPhotoIndex + 1;
  }
};

const navigateBackward = (selectedPhotoIndex: number, photoCount: number) => {
  switch (selectedPhotoIndex) {
    case 0:
      return photoCount - 1;
    default:
      return selectedPhotoIndex - 1;
  }
};

interface NavigationControlsProps {
  photoCount: number,
  onPhotoIndexChange: (i: number) => void,
  selectedPhotoIndex: number,
  isEditingPhoto: boolean,
  //state
  preferences: UserPreference[],
}

const NavigationControls = (props: NavigationControlsProps) => {

  useEffect(() => {
    const handleKeyUp = (event: KeyboardEvent) => {
      if (event.key === "ArrowRight") {
        props.onPhotoIndexChange(navigateForward(props.selectedPhotoIndex, props.photoCount));
      } else if (event.key === "ArrowLeft") {
        props.onPhotoIndexChange(navigateBackward(props.selectedPhotoIndex, props.photoCount));
      }
    };
    window.addEventListener("keyup", handleKeyUp);
    return () => {
      window.removeEventListener("keyup", handleKeyUp);
    };
  }, [props.selectedPhotoIndex, props.photoCount, props.onPhotoIndexChange]);

  const buttonsAlwaysVisible = getPhotoButtonHoverSetting(props.preferences) === photoToolButtonHoverOptions.SHOW_ALWAYS;

  return (
    <div className={`photo-tool-navigation-buttons${buttonsAlwaysVisible ? " always-show" : ""}`}>
      {!props.isEditingPhoto && //buttons always shown while not editing
        <>
          <div
            className="photo-navigation-control-right">
            <Button
              className="gallery-button gallery-button-right chevron-icon"
              floating
              title="Next"
              onClick={() => props.onPhotoIndexChange(navigateForward(props.selectedPhotoIndex, props.photoCount))}
            >
              keyboard_arrow_right
            </Button>
          </div>
          <div className="photo-navigation-control-left">
            <Button
              className="gallery-button gallery-button-left chevron-icon"
              floating
              title="Back"
              onClick={() => props.onPhotoIndexChange(navigateBackward(props.selectedPhotoIndex, props.photoCount))}
            >
              keyboard_arrow_left
            </Button>
          </div>
        </>
      }
    </div>
  );
};

const mapStateToProps = state => {
  return {
    preferences: state.preferences,
  };
};

export default connect(mapStateToProps, null)(NavigationControls);
